<div class="p-column-title">{{ title | translate }}</div>
<div class="p-column-content">
  <ng-content></ng-content>
</div>
